module.exports = __webpack_public_path__ + "img/banner-2.368afda9.png";